export const useAppTotalCount = () => {
  return {
    totalCount: "3700+",
    isLoading: false
  };
};